const fallbackCopyTextToClipboard = function (text) {
  const textArea = document.createElement("textarea")
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.select()

  try {
    document.execCommand("copy")
  } catch (err) {
    console.error(`Copy to clipboard failed, ${err}`)
    document.body.removeChild(textArea)
    throw err
  }

  document.body.removeChild(textArea)
}

// Inspiration: https://stackoverflow.com/a/30810322
export const write = async function (content) {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(content)
    } catch (err) {
      fallbackCopyTextToClipboard(content)
    }
  } else {
    fallbackCopyTextToClipboard(content)
  }
}
